import moment from "moment"
import React from "react"
import { AUSDIcon, PUSDIcon, USDTIcon, XPLIcon } from "../components/Global/CurrencyIcons"

export const COMPANY_NAME: string = "PULSEWORLD"
export const WEBSITE = "https://pulseworld.com"
export const COMPANY_EMAIL: string = "support@pulseworld.com"

export enum TOKEN {
    XPL = "XPL",
    AUSD = "AUSD",
    PUSD = "PUSD",
    USDT = "USDT"
}

export const TOKEN_COLORS = {
    XPL: '#F26BD4',
    PUSD: '#6289EE',
    AUSD: '#EEB662',
    USDT: '#53AE94',
}

export const SHADOW_CLASSES = {
    XPL: 'XPL-Shadow',
    PUSD: 'PUSD-Shadow',
    AUSD: 'AUSD-Shadow',
    USDT: 'USDT-Shadow',
}

/** Static icons only — use {@link getTokenRoundIcon} for XPL (component with unique SVG ids). */
export const TOKEN_ROUND_ICONS = {
    PUSD: PUSDIcon,
    AUSD: AUSDIcon,
    USDT: USDTIcon,
}

export function getTokenRoundIcon(symbol: string | undefined): React.ReactNode {
    if (!symbol) return null
    if (symbol === "XPL") return React.createElement(XPLIcon)
    return TOKEN_ROUND_ICONS[symbol as keyof typeof TOKEN_ROUND_ICONS] ?? null
}


export const POSITION_INDEX = {
    CUSTOMER: 0,
    SUBAGENT: 1,
    AGENT: 2,
    AREAMANAGER: 3,
}

export const REFFER_URL: string = WEBSITE + "/auth/signup?ref="


export const momentFormat = (date) => {
    return moment(new Date(date), "YYYYMMDD").fromNow()
}

export const formatDate = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD');
}

export enum LINK_TYPE {
    WIKI = "WIKI",
    LEGAL = "LEGAL"
}
